/**
 * Off-hub destinations the web app points at. Both are build-time settings
 * (deploy/pages/README.md) with the production defaults baked in.
 */

/** Where "Try the demo" goes: the balsam-demo Worker, unless the build says otherwise. */
export const DEMO_URL = (
  import.meta.env.VITE_DEMO_URL || 'https://demo.balsamsolutions.com'
).replace(/\/$/, '');

/** The address an account with no organization writes to for onboarding. */
export const CONTACT_EMAIL = import.meta.env.VITE_CONTACT_EMAIL || 'hello@balsamsolutions.com';
